<div class="w-full flex justify-center px-12 py-6 shadow-sm flex-wrap gap-2">
  <button class="bg-blue-800 text-white rounded-md p-3 flex items-center mx-4 " (click)="imprimer()">
    <mat-icon > local_printshop</mat-icon>Imprimer
  </button>
  <button  class="bg-green-600 text-white rounded-md p-3  flex items-center  mx-4" (click)="enregistrer()" >
    <mat-icon>save</mat-icon>Enregistrer
  </button>
</div>
<div class="py-8 px-50 flex flex-col justify-center">
  <ng-container>
    <mat-card class="example-card">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-card-header>
            <mat-card-title> Maladie Professionnelle</mat-card-title>
          </mat-card-header>
        </div>
        <mat-card-content class="border">
          <!-- <mat-card>
            <mat-card-content>
              <div class="flex justify-center">
                <img src="assets/cnamLogo.png" alt="" class="w-2/6" />
              </div>
            </mat-card-content>
          </mat-card> -->
          <mat-card>
            <mat-card-title>Employeur</mat-card-title>
            <mat-card-content fxLayout="column">
              <div fxLayout="row" fxLayoutAlign="center center" *ngIf="ListSoc">
                <mat-form-field appearance="legacy">
                  <mat-label>Choisir une Societé</mat-label>
                  <mat-select (selectionChange)="selectSoc($event.value)">
                    <mat-option *ngFor="let soc of ListSoc" [value]="soc.SOC_RS">{{soc.SOC_RS}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none" hidden="true">
                <span> Numéro d'affectation à la C.N.S.S : </span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>N° CNSS</mat-label>
                  <input matInput type="number" [(ngModel)]="nCnss">
                </mat-form-field>
                <div fxFlex="3"></div><span> Nom ou Raison Social :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Raison Social :</mat-label>
                  <input matInput type="text" [(ngModel)]="RS">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Adresse :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Adresse</mat-label>
                  <input matInput type="text" [(ngModel)]="adresse">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span> Code Postal :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Code Postal</mat-label>
                  <input matInput type="text" [(ngModel)]="codepostal">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> N° Téléphone :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label> N° Téléphone</mat-label>
                  <input matInput type="text" [(ngModel)]="nTel">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Nature de l'activité :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Nature de l'ativité</mat-label>
                  <input matInput type="text" [(ngModel)]="NatActivite">
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card>
            <mat-card-title>VICTIME</mat-card-title>
            <mat-card-content fxLayout="column">
              <div fxLayout="row" fxLayoutAlign="center ">
                <app-recherche [style]="{ width: '130px', 'margin-right': '10px' }" [api]="api" [(ngModel)]="persoRech"
                    [numColonneToShow]="1" [numColonneToReturn]="0" (ChampEnter)="blurPerso($event)"
                    recherche="API_PersoCnam2" name="PERSO" [param]="lastIdSoc" placeholder="Perso">
                  </app-recherche>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span> Numéro d'affectation à la C.N.S.S :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Numero Affectation</mat-label>
                  <input matInput type="text" [(ngModel)]="NumAffec">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Nom et Prénom :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Nom et Prénom</mat-label>
                  <input matInput type="text" [(ngModel)]="NpVic">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Prénom du pére </span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Prénom du pére :</mat-label>
                  <input matInput type="text" [(ngModel)]="PrPere">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Nom de jeune fille :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Nom de jeune fille</mat-label>
                  <input matInput type="text" [(ngModel)]="njFille">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span> Nationalité :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Nationalité</mat-label>
                  <input matInput type="text" [(ngModel)]="nat">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Sexe :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Sexe</mat-label>
                  <mat-select [(ngModel)]="Sexe">
                    <mat-option value="H">Homme</mat-option>
                    <mat-option value="F">Femme</mat-option>
                  </mat-select>
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Date de Naissance :</span>
                <div fxFlex="3"></div>
                <!-- <mat-form-field appearance="legacy" fxFlex="12" >
                  <mat-label>Date de naissance</mat-label>
                  <div fxFlex="3"></div>
                  <input matInput [matDatepicker]="pickerDateNais" [(ngModel)]="dateNais" (dateChange)="dateChange()">
                  <mat-datepicker-toggle matSuffix [for]="pickerDateNais"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDateNais ></mat-datepicker>
                </mat-form-field> -->
                <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date de Naissance </mat-label>
                  <input matInput [matDatepicker]="pickerDateNais" [(ngModel)]="dateNais"
                    (dateChange)="dateNaisChange()">
                  <mat-datepicker-toggle matSuffix [for]="pickerDateNais"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDateNais></mat-datepicker>
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Lieu de Naissance :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Nationalité</mat-label>
                  <input matInput type="text" [(ngModel)]="LieuNai">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span> N° C.I.N :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>C.I.N </mat-label>
                  <input matInput type="text" [(ngModel)]="cin">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Adresse du domicille :</span>
                <div fxFlex="3"></div>
                <mat-form-field>
                  <mat-label>Adresse </mat-label>
                  <div fxFlex="3"></div>
                  <input matInput type="text" [(ngModel)]="adresseDom">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Code Postal :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Code Postal</mat-label>
                  <input matInput type="text" [(ngModel)]="CodePostal">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span> Date d'Embauche :</span>
                <div fxFlex="3"></div>
                <!-- <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date :</mat-label>
                  <input matInput [matDatepicker]="pickerDateEmb" [(ngModel)]="dateEmb">
                  <mat-datepicker-toggle matSuffix [for]="pickerDateEmb"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDateEmb></mat-datepicker>
                </mat-form-field> -->
                <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date d'Embauche </mat-label>
                  <input matInput [matDatepicker]="pickerDateEmb" [(ngModel)]="dateEmb" (dateChange)="dateEmbChange()">
                  <mat-datepicker-toggle matSuffix [for]="pickerDateEmb"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDateEmb></mat-datepicker>
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Qualification Professionnelle :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Qualification Professionnelle</mat-label>
                  <input matInput type="text" [(ngModel)]="qualifPro">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Status :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Status</mat-label>
                  <input matInput type="text" [(ngModel)]="Status">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Emploi habituel :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Emploi Habituel</mat-label>
                  <input matInput type="text" [(ngModel)]="EmpHabit">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span> depuis :</span>
                <div fxFlex="3"></div>
                <mat-form-field appearance="legacy" fxFlex="19">
                  <mat-label>Depuis </mat-label>
                  <input matInput [matDatepicker]="pickerdepuis" [(ngModel)]="depuis"
                    (dateChange)="depuisChange()">
                  <mat-datepicker-toggle matSuffix [for]="pickerdepuis"></mat-datepicker-toggle>
                  <mat-datepicker #pickerdepuis></mat-datepicker>
                </mat-form-field>
                <div fxFlex="3"></div>
                <span> Adresse du lieu de travail habituel :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Adresse</mat-label>
                  <input matInput type="text" [(ngModel)]="adrHabTrav">
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
          <mat-card>
            <mat-card-title>Maladie Professionnelle</mat-card-title>
            <mat-card-content fxLayout="column">
              <div fxLayout="row" fxLayoutAlign="start none">
                <span>Désignation de la maladie</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Désignation</mat-label>
                  <input matInput type="text" [(ngModel)]="desMal">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span>N°du tableau corréspondant</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>N° Tableau</mat-label>
                  <input matInput type="text" [(ngModel)]="nTabCor">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span>Constatation de la maladie par nom (nom du médecin)</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Constatation de la maladie</mat-label>
                  <input matInput type="text" [(ngModel)]="consMal">
                </mat-form-field>
                <span>Date maladie</span>
                <div fxFlex="3"></div>
                <!-- <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date </mat-label>
                  <input matInput [matDatepicker]="pickerDatee" [(ngModel)]="dateMal">
                  <mat-datepicker-toggle matSuffix [for]="pickerDatee"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDatee></mat-datepicker>
                </mat-form-field> -->
                <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date maladie </mat-label>
                  <input matInput [matDatepicker]="pickerDatee" [(ngModel)]="dateMal" (dateChange)="dateMalChange()">
                  <mat-datepicker-toggle matSuffix [for]="pickerDatee"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDatee></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span>Nature de travail</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="20">
                  <mat-label>Nature de travail</mat-label>
                  <textarea matInput rows="1" [(ngModel)]="natTrav"></textarea>
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="start none">
                <span>Date de cessation d'exposition à l'agent nocif</span>
                <div fxFlex="3"></div>
                <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date de cessation </mat-label>
                  <input matInput type="text" [(ngModel)]="agentNoc">
                </mat-form-field>
                <div fxFlex="3"></div>
                <!-- <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date </mat-label>
                  <input matInput [matDatepicker]="pickerDate2" [(ngModel)]="dateAgentNoct">
                  <mat-datepicker-toggle matSuffix [for]="pickerDate2"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDate2></mat-datepicker>
                </mat-form-field> -->
                <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date </mat-label>
                  <input matInput [matDatepicker]="pickerDate2" [(ngModel)]="dateAgentNoct"
                    (dateChange)="dateAgenChange()">
                  <mat-datepicker-toggle matSuffix [for]="pickerDate2"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDate2></mat-datepicker>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayoutAlign="start none">
                <span>A-t-elle entrainé un arrêt de travail</span>
                <div fxLayout="row" fxLayoutAlign="start none">
                  <mat-radio-group fxLayoutAlign="space-between center" [(ngModel)]="entArret"
                    (change)="selectArret($event)">
                    <mat-radio-button value="1">Oui </mat-radio-button>
                    <mat-radio-button value="0">Non </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>


            </mat-card-content>
          </mat-card>
          <mat-card *ngIf="entArret=='1'">
            <mat-card-title>En cas d'arrêt de travail</mat-card-title>
            <mat-card-content fxLayout="column">
              <div fxLayout="row" fxLayoutAlign="start none">
                <span>Date d'arrêt de travail :</span>
                <div fxFlex="3"></div>
                <!-- <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date :</mat-label>
                  <input matInput [matDatepicker]="pickerDateArret" [(ngModel)]="dateArret">
                  <mat-datepicker-toggle matSuffix [for]="pickerDateArret"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDateArret></mat-datepicker>
                </mat-form-field> -->
                <mat-form-field appearance="legacy" fxFlex="12">
                  <mat-label>Date </mat-label>
                  <input matInput [matDatepicker]="pickerDateArret" [(ngModel)]="dateArret"
                    (dateChange)="dateArretChange()">
                  <mat-datepicker-toggle matSuffix [for]="pickerDateArret"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDateArret></mat-datepicker>
                </mat-form-field>
                <div fxFlex="3"></div>
                <span>Le salaire est-il maintenu ?</span>
                <div fxFlex="3"></div>
                <mat-radio-group fxLayoutAlign="space-between center" [(ngModel)]="salaireMaintenu">
                  <mat-radio-button value="1">Oui </mat-radio-button>
                  <mat-radio-button value="0">Non </mat-radio-button>
                </mat-radio-group>
              </div>
              <div *ngIf="salaireMaintenu=='1'"fxLayout="row" fxLayoutAlign="start none">
                <span>Si oui, pour une durée de :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Durée</mat-label>
                  <input matInput type="text" [(ngModel)]="dureeArret">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span>Et au montant de :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Montant</mat-label>
                  <input matInput type="text" [(ngModel)]="montantArret">
                </mat-form-field>
                <div fxFlex="3"></div>
                <span>Par :</span>
                <div fxFlex="3"></div>
                <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
                  <mat-label>Par</mat-label>
                  <input matInput type="text" [(ngModel)]="parArret">
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-raised-button color="primary" (click)="openDialogAdd(1)">Ajouter <mat-icon>add</mat-icon>
            </button>
          </div>
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="RaisonAdr">
              <th mat-header-cell *matHeaderCellDef> Raison Sociale,Adresse de l'employeur et n°CNSS</th>
              <td mat-cell *matCellDef="let element"> {{element.RaisonAdr}} </td>
            </ng-container>
            <ng-container matColumnDef="NatureDeTravail">
              <th mat-header-cell *matHeaderCellDef> Nature de Travail </th>
              <td mat-cell *matCellDef="let element"> {{element.NatureDeTravail}} </td>
            </ng-container>
            <ng-container matColumnDef="AgentsNocifs">
              <th mat-header-cell *matHeaderCellDef> Agents Nocifs </th>
              <td mat-cell *matCellDef="let element"> {{element.AgentsNocifs}} </td>
            </ng-container>
            <ng-container matColumnDef="periode">
              <th mat-header-cell *matHeaderCellDef> Période </th>
              <td mat-cell *matCellDef="let element"> {{element.periode}} </td>
            </ng-container>
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef> Action</th>
              <td mat-cell *matCellDef="let emb">
                <mat-icon (click)="modifer(emb)">update</mat-icon>
                <mat-icon (click)="openDialogueDelete(emb)">delete</mat-icon>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </mat-card-content>
        <mat-card-footer fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="start none">
            <div fxFlex="2"></div>
            <span fxLayoutAlign="space-between center">Je soussigné (nom et prénoms) :</span>
            
            <!-- <mat-form-field id="example-full-width" appearance="legacy">
              <mat-label>Nom & Prénom</mat-label>
              <input matInput type="text" [(ngModel)]="nompSous">
            </mat-form-field>
            <div fxFlex="3"></div>
            <span fxLayoutAlign="space-between center">Déclare sur l’honneur, en ma qualité :</span>
            <div fxFlex="3"></div>
            <mat-form-field id="example-full-width" appearance="legacy">
              <mat-label>Fonction</mat-label>
              <input matInput type="text" [(ngModel)]="postSous">
            </mat-form-field> -->
            <app-recherche [style]="{ width: '130px', 'margin-right': '10px' }" [api]="api" [(ngModel)]="persoSousRech"
                    [numColonneToShow]="1" [numColonneToReturn]="0" (ChampEnter)="blurPersoSS($event)"
                    recherche="API_PersoCnamSig"  [param]="lastIdSoc" placeholder="Nom & Prénom">
                  </app-recherche>
                  <div fxFlex="3"></div>
                  <div fxFlex="2"></div> <span fxLayoutAlign="space-between center"> Fait à :</span>
            <div fxFlex="3"></div>
            <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
              <mat-label>Fait à</mat-label>
              <input matInput type="text" [(ngModel)]="faitA">
            </mat-form-field>
            <span fxLayoutAlign="space-between center"> le :</span>
            <div fxFlex="3"></div>
            <mat-form-field appearance="legacy" fxFlex="12">
              <mat-label>Date </mat-label>
              <input matInput [matDatepicker]="pickerDate" [(ngModel)]="le" (dateChange)="dateLe()">
              <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
              <mat-datepicker #pickerDate></mat-datepicker>
            </mat-form-field>
          </div>    
        </mat-card-footer>
      </mat-card>
    </mat-card>

  </ng-container>
</div>

<div style="display: none;">
<div id="mp" style="position: relative" >
  <div style="background-size: cover;
   width: 1654px;height: 2339px;position: absolute;"
  [style]="{top:impTop+'px'}">
    <span style="
    position: absolute;
    top: 423px;
    left: 1130px;font-size: 30px;">
      {{nCnss}}
    </span>
    <span style="
    position: absolute;
    top: 465px;
    left: 390px;font-size: 30px;">
      {{RS}}
    </span>
    <span style="
    position: absolute;
    top: 505px;
    left: 275px;font-size: 30px;">
      {{adresse}}
    </span>
    <span style="
    position: absolute;
    top: 545px;
    left: 785px;font-size: 30px;">
      {{codepostal}}
    </span>
    <span style="
    position: absolute;
    top: 545px;
    left: 1110px;font-size: 30px;">
      {{nTel}}
    </span>
    <span style="
    position: absolute;
    top: 580px;
    left: 370px;font-size: 30px;">
      {{NatActivite}}
    </span>
    <span style="
    position: absolute;
    top: 649px;
    left: 1062px;font-size: 30px;">
      {{NumAffec}}
    </span>
    <span style="
    position: absolute;
    top: 695px;
    left: 360px;font-size: 30px;">
      {{NpVic}}
    </span>
    <span style="
    position: absolute;
    top: 695px;
    left: 1085px;font-size: 30px;">
      {{PrPere}}
    </span>
    <span style="
    position: absolute;
    top: 740px;
    left: 360px;font-size: 30px;">
      {{njFille}}
    </span>
    <span style="
    position: absolute;
    top: 740px;
    left: 810px;font-size: 30px;">
      {{nat}}
    </span>
    <span *ngIf="Sexe=='H'" style="
    position: absolute;
    top: 765px;
    left: 1220px;font-size: 30px;">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
    </span>
    <span *ngIf="Sexe=='F'" style="
    position: absolute;
    top: 765px;
    left: 1275px;font-size: 30px;">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
    </span>
    <span style="
    position: absolute;
    top: 783px;
    left: 450px;font-size: 30px;">
      {{dateNaisSpan}}
    </span>
    <span style="
    position: absolute;
    top: 783px;
    left: 720px;font-size: 30px;">
      {{LieuNai}}
    </span>
    <span style="
    position: absolute;
    top: 783px;
    left: 1090px;font-size: 30px;">
      {{cin}}
    </span>
    <span style="
    position: absolute;
    top: 830px;
    left: 390px;font-size: 30px;">
      {{adresseDom}}
    </span>
    <span style="
    position: absolute;
    top: 854px;
    left: 1220px;font-size: 30px;">
      {{CodePostal}}
    </span>
    <span style="
    position: absolute;
    top: 883px;
    left: 394px;font-size: 30px;">
      {{dateEmbSpan}}
    </span>
    <span style="
    position: absolute;
    top: 893px;
    left: 986px;font-size: 30px;">
      {{qualifPro}}
    </span>
    <span style="
    position: absolute;
    top: 893px;
    left: 1276px;font-size: 30px;">
      {{Status}}
    </span>
    <span style="
    position: absolute;
    top: 932px;
    left: 370px;font-size: 30px;">
      {{EmpHabit}}
    </span>
    <span style="
    position: absolute;
    top: 925px;
    left: 1045px;font-size: 30px;">
      {{datedepuis}}
    </span>
    <span style="
    position: absolute;
    top: 966px;
    left: 515px;font-size: 30px;">
      {{adrHabTrav}}
    </span>
    <span style="
    position: absolute;
    top: 1109px;
    left: 480px;font-size: 30px;">
      {{desMal}}
    </span>
    <span style="
    position: absolute;
    top: 1110px;
    left: 1200px;font-size: 30px;">
      {{nTabCor}}
    </span>
    <span style="
    position: absolute;
    top: 1156px;
    left: 670px;font-size: 30px;">
      {{consMal}}
    </span>
    <span style="
    position: absolute;
    top: 1145px;
    left: 1140px;font-size: 30px;">
      {{dateMalSpan}}
    </span>
    <span style="
    position: absolute;
    top: 1200px;
    left: 400px;font-size: 30px;">
      {{natTrav}}
    </span>
    <span style="
    position: absolute;
    top: 1244px;
    left: 633px;font-size: 30px;">
      {{agentNoc}}
    </span>
    <span style="
    position: absolute;
    top: 1238px;
    left: 1140px;font-size: 30px;">
      {{dateAgenNocSpan}}
    </span>
    <span *ngIf="entArret=='1'" style="
    position: absolute;
    top: 1294px;
    left: 695px;font-size: 30px;">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
    </span>
    <span *ngIf="entArret=='0'" style="
    position: absolute;
    top: 1294px;
    left: 885px;font-size: 30px;">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
    </span>
    <span style="
    position: absolute;
    top: 1379px;
    left: 520px;font-size: 30px;">
      {{dateArretSpan}}
    </span>
    <span *ngIf="salaireMaintenu=='1'" style="
    position: absolute;
    top: 1400px;
    left: 1160px;font-size: 30px;">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
    </span>
    <span *ngIf="salaireMaintenu=='0'" style="
    position: absolute;
    top: 1400px;
    left: 1315px;font-size: 30px;">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
    </span>
    <span style="
    position: absolute;
    top: 1445px;
    left: 417px;font-size: 30px;">
      {{dureeArret}}
    </span>
    <span style="
    position: absolute;
    top: 1433px;
    left: 918px;font-size: 30px;">
      {{montantArret}}
    </span>
    <span style="
    position: absolute;
    top: 1445px;
    left: 1215px;font-size: 30px;">
      {{parArret}}
    </span>
    <!-- premiere ligne -->
    <div *ngFor="let line of listTable">
      <span [ngStyle]="line.StyleSpanrsCNSS">
        {{line.RaisonAdr}}
      </span>
      <span [ngStyle]="line.StyleSpannatTrv">
        {{line.NatureDeTravail}}
      </span>
      <span [ngStyle]="line.StyleSpanAgent">
        {{line.AgentsNocifs}}
      </span>
      <span [ngStyle]="line.StyleSpanDu">
        {{line.periode.substring(3,13)}}
      </span>
      <span [ngStyle]="line.StyleSpanAu">
        {{line.periode.split('Au ')[1]}}
      </span>
    </div>
    <span style="
    position: absolute;
    top: 2148px;
    left: 400px;font-size: 30px;">
      {{nompSous}}
    </span>
    <span style="
    position: absolute;
    top: 2176px;
    left: 200px;font-size: 30px;">
      {{postSous}}
    </span>
    <span style="
    position: absolute;
    top: 2290px;
    left: 1360px;font-size: 30px;">
      {{faitA}}
    </span>
    <span style="
    position: absolute;
    top: 2290px;
    left: 1509px;font-size: 30px;">
      {{dateLeSpan}}
    </span>
  </div>
</div>
</div>

<ng-template #frmDelete>
  <ng-container class="py-8 w-full" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-card-title style="color:#1e88e5;" class="text-4xl text-center">Voulez vous Supprimer ? </mat-card-title>
    </div>
    <br>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial (click)="supprimer()">
        <mat-icon class="mr-2">check</mat-icon>Oui
      </button>
      <div fxFlex="10"></div>
      <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial (click)="close()">
        <mat-icon class="mr-2">close</mat-icon>Non
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #frmadd>
  <ng-container class="py-8 w-full" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-card-title style="color:#1e88e5;" class="text-4xl text-center">Titre </mat-card-title>
    </div>
    <div fxLayout="column">
      <br>
      <div fxLayout="row" fxLayoutAlign="start none">
        <mat-form-field id="example-full-width" appearance="legacy" fxFlex="25">
          <mat-label>Raison Socila,Adresse,N°CNSS</mat-label>
          <input matInput type="text" [(ngModel)]="rsCNSS">
        </mat-form-field>
        <div fxFlex="5"></div>
        <mat-form-field id="example-full-width" appearance="legacy" fxFlex="20">
          <mat-label>Nature de travail</mat-label>
          <input matInput type="text" [(ngModel)]="natTrv">
        </mat-form-field>
        <div fxFlex="5"></div>
        <mat-form-field appearance="legacy" fxFlex="20">
          <mat-label>Agent Nocifs</mat-label>
          <input matInput type="text" [(ngModel)]="agentNs">
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start none">
        <mat-form-field appearance="legacy" fxFlex="20">
          <mat-label>Du</mat-label>
          <input matInput [matDatepicker]="pickerdu" id="du">
          <mat-datepicker-toggle matSuffix [for]="pickerdu"></mat-datepicker-toggle>
          <mat-datepicker #pickerdu></mat-datepicker>
        </mat-form-field>
        <div fxFlex="5"></div>
        <mat-form-field appearance="legacy" fxFlex="20">
          <mat-label>Au</mat-label>
          <input matInput [matDatepicker]="pickerau" id="au">
          <mat-datepicker-toggle matSuffix [for]="pickerau"></mat-datepicker-toggle>
          <mat-datepicker #pickerau></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
      <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial (click)="save()">
        <mat-icon class="mr-2">save</mat-icon>Enregistrer
      </button>
      <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial (click)="close()">
        <mat-icon class="mr-2">close</mat-icon>Fermer
      </button>
    </div>
  </ng-container>
</ng-template>
